import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import NewHomePage from "@/pages/NewHomePage";
import BridalServices from "@/pages/BridalServices";
import CoursesPage from "@/pages/CoursesPage";
import ClassVideosPage from "@/pages/ClassVideosPage";
import BridalPortfolioPage from "@/pages/BridalPortfolioPage";
import ModelPortfolioPage from "@/pages/ModelPortfolioPage";
import MoreReviewsPage from "@/pages/MoreReviewsPage";
import MoreBrideStoriesPage from "@/pages/MoreBrideStoriesPage";
import TrendyHairstylesPage from "@/pages/TrendyHairstylesPage";
import StudentDashboard from "@/pages/StudentDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import TeacherDashboard from "@/pages/TeacherDashboard";
import ScheduleDetails from "@/pages/ScheduleDetails";
import TermsAndConditions from "@/pages/TermsAndConditions";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import RefundPolicy from "@/pages/RefundPolicy";
import AboutUs from "@/pages/AboutUs";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<NewHomePage />} />
          <Route path="/old-home" element={<LandingPage />} />
          <Route path="/bridal-services" element={<BridalServices />} />
          <Route path="/courses" element={<CoursesPage />} />
          <Route path="/class-videos" element={<ClassVideosPage />} />
          <Route path="/bridal-portfolio" element={<BridalPortfolioPage />} />
          <Route path="/model-portfolio" element={<ModelPortfolioPage />} />
          <Route path="/more-reviews" element={<MoreReviewsPage />} />
          <Route path="/more-bride-stories" element={<MoreBrideStoriesPage />} />
          <Route path="/trendy-hairstyles" element={<TrendyHairstylesPage />} />
          <Route path="/student" element={<StudentDashboard />} />
          <Route path="/student/schedule/:module" element={<ScheduleDetails />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/teacher" element={<TeacherDashboard />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/about-us" element={<AboutUs />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;